import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LinearProgress } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import useSidebarState from 'components/Sidebar/hooks/useSidebarState';

const LoaderBox = styled.div`
  position: absolute;
  ${({ left }) => `left: ${left}`};
  ${({ width }) => `width: ${width}`};
  z-index: 1200;
  ${({ top }) => `top: ${top}`};
`;
const StyledLinearProgress = styled(LinearProgress)`
  width: 70%;
`;
export const CenterLoader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(oldProgress => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 20;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);
  return (
    <Flex
      width='100%'
      height='100vh'
      justify='center'
      content='center'
      items='center'
    >
      <StyledLinearProgress variant='determinate' value={progress} />
    </Flex>
  );
};

const Loader = ({ disable, top }) => {
  const { topbarHeight, sidebarWidth } = useSidebarState();
  const style = {
    left: sidebarWidth,
    width: `calc(100% - ${sidebarWidth})`
  };
  return (
    <LoaderBox top={top || topbarHeight} {...style}>
      {!disable && <LinearProgress />}
    </LoaderBox>
  );
};

export default Loader;
